import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAuth } from "../AuthProvider.tsx";
import { buildApiUrl } from "../services/apiConfig.ts";
import "./overview.css";

export default function AcceptOrganizationInvitation() {
  const { token } = useParams();
  const { fetchWithAuth } = useAuth();
  const [message, setMessage] = useState("Einladung wird angenommen …");
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (!token) return setMessage("Der Einladungslink ist ungültig.");
    fetchWithAuth(buildApiUrl(`/organization/invitations/${encodeURIComponent(token)}/accept`), { method: "POST" })
      .then(async response => {
        if (!response.ok) throw new Error(await response.text());
        setAccepted(true);
        setMessage("Du bist der Organisation beigetreten.");
      })
      .catch(error => setMessage(error.message));
  }, [fetchWithAuth, token]);

  return <div className="portal-root"><main className="portal-main"><section className="portal-panel">
    <h1>Organisationseinladung</h1><p>{message}</p>
    {accepted && <Link className="btn dark" to="/">Zum Portal</Link>}
  </section></main></div>;
}
